import SEO from "../components/SEO";
import { Reveal, LineReveal } from "../components/Reveal";
import { ActivityCard } from "../components/cards";
import CommunityTiles from "../components/CommunityTiles";
import { getActivities } from "../lib/content";
import { Link } from "react-router-dom";

export default function Activities() {
  return (
    <main>
      <SEO
        title="Activities"
        description="The longer-running initiatives PilCoo is working on — walking challenges, meal sponsorships, clean-ups and more."
        path="/activities"
      />
      <section className="pt-32 md:pt-44 pb-16 md:pb-20" data-testid="activities-header">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <p className="text-xs uppercase tracking-[0.25em] font-medium text-ink-2">Current activities</p>
          <h1 className="mt-6 font-serif tracking-tighter leading-[0.98] text-ink text-5xl sm:text-6xl lg:text-7xl">
            <LineReveal lines={["Kindness in Motion"]} delay={0.15} />
          </h1>
          <Reveal delay={0.4}>
            <p className="mt-8 max-w-2xl text-base md:text-lg leading-relaxed text-ink-2">
              Ongoing initiatives and community challenges that give you a way
              to take part — at your own pace, in your own way. Some run for a
              season, some stay open. (For what's happening at a specific time
              and place, see{" "}
              <Link to="/events" className="underline underline-offset-4 text-ink font-medium">
                Events
              </Link>
              .)
            </p>
            <p className="mt-4 text-sm text-ink-2 max-w-xl leading-relaxed">
              More initiatives across People and Nature are being shaped — they'll
              appear here when they're real, not before.
            </p>
          </Reveal>
        </div>
      </section>

      <section className="pb-24 md:pb-32" data-testid="activities-grid">
        <div className="max-w-7xl mx-auto px-6 md:px-12 grid grid-cols-1 gap-6">
          {getActivities().map((activity, i) => (
            <Reveal key={activity.slug} delay={i * 0.1}>
              <ActivityCard activity={activity} featured />
            </Reveal>
          ))}
        </div>
      </section>

      <section className="pb-24 md:pb-32" data-testid="activities-community">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <Reveal>
            <h2 className="font-serif text-3xl md:text-5xl tracking-tight text-ink">
              Stay part of the movement.
            </h2>
          </Reveal>
          <CommunityTiles
            testIdPrefix="activities-community-tile"
            tiles={[
              {
                key: "pacer",
                eyebrow: "Pacer Community",
                title: "Keep moving with PilCoo",
                text: "Join our Pacer Community — discover and take part in current and future movement-led challenges.",
                cta: "Join our Pacer Community",
              },
              {
                key: "whatsapp",
                eyebrow: "WhatsApp Channel",
                title: "Stay connected",
                text: "Follow The PilCoo Foundation on WhatsApp for new activities, volunteering opportunities, events, stories and ways to participate.",
                cta: "Follow our WhatsApp Channel",
              },
            ]}
          />
        </div>
      </section>
    </main>
  );
}
